export default "__VITE_ASSET__Bxa6ufLg__"